import { render, staticRenderFns } from "./MenuButtons.vue?vue&type=template&id=22b5826a&"
import script from "./MenuButtons.vue?vue&type=script&lang=ts&"
export * from "./MenuButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports